enum OperatingSystem {
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    OSX = 'OSX',
    WINDOWS = 'WINDOWS',
    LINUX = 'LINUX',
    UNKNOWN = 'UNKNOWN'
}

export default OperatingSystem;